module.exports = __webpack_public_path__ + "static/media/2_placeholder_it.8ebd7840.png";